import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import FavoriteIcon from '@mui/icons-material/Favorite';
import EditIcon from '@mui/icons-material/Edit';

import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import {setLookActiveCategory, setLookOverlayOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import WithSavePostMessage from "../../hocs/withSavePostMessage";
// import {LOOK_OPENED_TYPES} from "../../core/constants";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import LookCanvasContext from "../../lookCanvasContext";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {isIframe} from "../../../../misc/helpers";

const LookListMainFeatureActionsPopperButtons = (props) => {

  const {closePopper, cartItem, setLookPageOpened, setLookActiveCategory, fabricatorData} = props;

  const isLixil = isIframe() && fabricatorData.isLixil;

  const addToWishListButtonCLick = (savePostMessage) => {
    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemMoreDropdownWishlist + featureLabel);

    closePopper();
    savePostMessage(cartItem);
  }

  const changeItemButtonCLick = (zoomToFeatureGroup) => {
    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemMoreDropdownChange + featureLabel);

    closePopper();
    setLookPageOpened("");
    zoomToFeatureGroup(cartItem.partId, cartItem.cartFeature);
    setTimeout(() => {
      setLookActiveCategory(cartItem.partId);
    }, 300)
  }

  return (
    <MenuList id="menu-list-grow">
      {isLixil ? (
        <WithSavePostMessage>
          {(savePostMessage) => (
            <MenuItem className="look-sidebar__modal-item" onClick={() => addToWishListButtonCLick(savePostMessage)}>
              <ListItemIcon>
                <FavoriteIcon/>
              </ListItemIcon>
              <FormattedMessage id="look.list.feature.addToWishList"/>
            </MenuItem>
          )}
        </WithSavePostMessage>
      ) : null}
      <LookCanvasContext.Consumer>
        {(imageCanvas) => (
          <WithZoomToFeature imageCanvas={imageCanvas}>
            {(zoomToFeatureGroup) => (
              <MenuItem className="look-sidebar__modal-item" onClick={() => changeItemButtonCLick(zoomToFeatureGroup)}>
                <ListItemIcon>
                  <EditIcon/>
                </ListItemIcon>
                <FormattedMessage id="look.list.feature.changeItem"/>
              </MenuItem>
            )}
          </WithZoomToFeature>
        )}
      </LookCanvasContext.Consumer>
    </MenuList>
  )
};

LookListMainFeatureActionsPopperButtons.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
  closePopper: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setLookActiveCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookListMainFeatureActionsPopperButtons)
